import { useMemo } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import type { HotelResponse } from '@/interfaces';

const DEFAULT_IMAGE = 'https://www.finn.no/assets/finn-logo-large.png';

export const useHotelSeo = (hotel: HotelResponse | null | undefined) => {
    const { imgPath, contextPathPP } = useConfig();

    return useMemo(() => {
        const hasHotel = Boolean(hotel?.id);

        const title = hasHotel ? `Pakkereiser til ${hotel.name}` : 'Dette hotellet finnes ikke :(';

        const description = hasHotel
            ? `${hotel.name}, ${hotel.destination}, ${hotel.region}, ${hotel.country}`
            : 'Vi kunne dessverre ikke finne dette hotellet';

        const url = hasHotel ? `https://www.finn.no${contextPathPP}/hotell?hotellId=${hotel.id}` : undefined;

        const image = hasHotel && hotel.imagePaths?.length ? `${imgPath}1280w${hotel.imagePaths[0]}` : DEFAULT_IMAGE;

        return {
            title,
            description,
            url,
            image,
        };
    }, [hotel, imgPath, contextPathPP]);
};
